export const handleBodyScrollEnd = ({ gridRef, event, onBodyScrollverticalEndToTheBottom }) => {
    if (onBodyScrollverticalEndToTheBottom && gridRef.current) {
        const bottomPx = gridRef.current.api.getVerticalPixelRange().bottom;
        const gridContainer = gridRef.current?.parentEl?.current?.querySelector?.(".ag-body-vertical-scroll-container");
        const gridHeight = gridContainer?.clientHeight ?? 0;
        if (bottomPx >= gridHeight - 2) {
            onBodyScrollverticalEndToTheBottom(event);
        }
    }
};
